import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    partnerId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.orgPartner.myOrgAddPartner, {
        partnerId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
